import React, { useState, useCallback, useEffect, useRef } from 'react';
import { IoMdArrowBack, IoMdArrowForward } from 'react-icons/io';
import ContainedButton from 'components/layout/form/containedButton';
import OutlinedButton from 'components/layout/form/outlinedButton';
import { HeaderContainer } from "../styles";
import { Container, ContainerButtons, FormContainer, TextTimer } from './styles';
import { toast } from 'react-toastify';
import { sendToken, validationToken } from '../utils';
import TextField from "components/layout/form/textField";
import * as Yup from "yup";
import { Field, Formik } from "formik";

const formatTimer = (timer) => {
  let minutes = parseInt(timer / 60, 10);
  let seconds = parseInt(timer % 60, 10);
  minutes = minutes < 10 ? "0" + minutes : minutes;
  seconds = seconds < 10 ? "0" + seconds : seconds;
  return minutes + ":" + seconds;
};

const ValidationToken = ({ setStep, userInfo, setUserInfo, contactId = null }) => {
  const [loading, setLoading] = useState();
  const [timer, setTimer] = useState(60);
  const [startTimer, setStartTimer] = useState(false);

  const intervalRef = useRef();
  let newTimer = 60;

  const decreaseNum = () => {
    if (newTimer === 0) {
      setStartTimer(false);
      clearInterval(intervalRef.current);
      return;
    }
    setTimer((prev) => {
      newTimer = newTimer - 1;
      return prev - 1;
    })
  };

  useEffect(() => {
    if (startTimer) {
      intervalRef.current = setInterval(decreaseNum, 1000);
    }

    return () => clearInterval(intervalRef.current);
  }, [startTimer]);

  useEffect(() => {
    setStartTimer(true);
  }, []);

  const contact = userInfo.contacts?.find(contact => contact.contactId === userInfo?.validationContactId);

  const resendToken = async () => {
    setLoading(true);
    const success = await sendToken(contact, userInfo?.userId, contactId);
    if (success) {
      setTimer(60);
      setStartTimer(true);
    }
    setLoading(false);
  }

  const handleSubmit = useCallback(async(values) => {
    if(!loading) {
      setLoading(true);
      const success = await validationToken(values?.token, userInfo?.userId);
      if (success) {
        setStep(4);
        setUserInfo({ ...userInfo, token: values?.token });
      }
      setLoading(false);
    }
  }, [validationToken, loading]);

  const validatorSchema = () => Yup.object().shape({
    token: Yup.string().required("É necessário inserir o token"),
  });

  return (
    <Container>
      <HeaderContainer>
        <h1>Insira o código</h1>
        <h2>Informe o código enviado em seu {contact?.contactType === 'PHONE' ? 'telefone' : 'email'}</h2>
      </HeaderContainer>

      <Formik
        initialValues={{
          token: "",
        }}
        validationSchema={validatorSchema}
        onSubmit={handleSubmit}
        render={({ handleChange, handleBlur, values, errors, touched }) => (
          <FormContainer>
            <Field
              name="token"
              render={({ field }) => (
                <TextField
                  {...field}
                  label="Iserir código"
                  placeholder="Iserir código"
                  errorCondition={errors.token && touched.token}
                  errorMessage={errors.token}
                  isCorrect={!errors.token}
                  value={values.token}
                  onBlur={handleBlur}
                  onClick={() => toast.dismiss()}
                  onChange={handleChange}
                />
              )}
            />
            <TextTimer>Não recebi o código. {timer > 0 ? `Aguarde ${formatTimer(timer)}` : <a href="#" onClick={resendToken}>Enviar novamente</a>}</TextTimer>
            <ContainerButtons>
              <ContainedButton
                block
                type="submit"
                continue
                loading={loading}
                disabled={loading || !values.token}
                id="Avançar"
                width="100%"
                TrailingIcon={() => <IoMdArrowForward size={20} />}
              >
                Validar código
              </ContainedButton>
              <OutlinedButton
                width="100%"
                LeadingIcon={() => <IoMdArrowBack size={20} />}
                onClick={() => setStep(2)}
              >
                Voltar
              </OutlinedButton>
            </ContainerButtons>
          </FormContainer>
        )}
      />
    </Container>
  );
};

export default ValidationToken;
